<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div v-if="resData" class="package-box">
      <el-dialog
        :visible="show"
        style="width：300px;"
        :before-close="onCloseDialog"
      >
        <div class="work-title">
          <h3 style="margin: 0">工单：{{ work_id }}</h3>
        </div>
        <div class="header-box">拆包信息</div>
        <el-form
          v-if="resData.work"
          ref="form"
          :model="form"
          label-width="130px"
        >
          <el-form-item label="寄回运单号：">
            <div>{{ resData.work.back_shipping_num }}</div>
          </el-form-item>
          <el-form-item label="商品名称:">
            {{ resData.work.goods_name }}
          </el-form-item>
          <el-form-item label="商品图片：">
            <div style="width: 50px; height: 50px">
              <img
                style="height: 100%; width: 100%"
                :src="resData.work.main_img"
                @click="imgClick(resData.work.middle_img)"
              />
            </div>
          </el-form-item>
          <el-form-item label="用户上传图片：" style="margin-top: 10px">
            <div style="width: 50px; height: 50px">
              <img
                v-viewer
                style="height: 100%; width: 100%"
                :src="resData.work.picture"
              />
            </div>
          </el-form-item>
          <el-form-item label="颜色-尺码：">
            <div>{{ resData.work.co_val }}/{{ resData.work.si_val }}</div>
          </el-form-item>
          <el-form-item label="问题类型:">
            <el-select v-model="model.id" size="small">
              <el-option :value="0" label="全部"></el-option>
              <el-option
                v-for="item in problem"
                :key="item.problem_id"
                :value="item.problem_id"
                :label="item.problem_name"
              ></el-option>
            </el-select>
            <el-select v-model="model.sub_id" size="small">
              <el-option :value="0" label="全部"></el-option>
              <el-option
                v-for="item in subPorblem"
                :key="item.problem_id"
                :value="item.problem_id"
                :label="item.problem_name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="拆包件数：">
            <div>{{ resData.work.num }}</div>
          </el-form-item>
          <el-form-item label="登记类型：">
            <el-table :data="resData.work_dbid" style="width: 100%">
              <el-table-column prop="blp_type_index" label="类型">
                <template slot-scope="scope">
                  {{ getBlpText(scope.row.blp_type_index) }}
                </template>
              </el-table-column>
              <el-table-column prop="num" label="数量"> </el-table-column>
              <el-table-column prop="blp_note" label="备注"> </el-table-column>
              <el-table-column prop="blp-img-up" label="图片">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.blp_img && scope.row.num > 0"
                    ref="“uploadImg”"
                    v-viewer
                    class="blp-img-up"
                  >
                    <img
                      v-if="scope.row.blp_img"
                      :src="scope.row.blp_img"
                      class="avatar"
                      style="width: 50px; height: 50px"
                    />
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <div v-if="handle_type_index == 1">
          <!-- 收件人信息 -->
          <div class="header-box">
            收件人信息<span style="font-size: 14px; color: red"
              >（如不填写，默认为原订单收件人地址）</span
            >
          </div>
          <el-form ref="form" :model="form" label-width="130px">
            <el-form-item label="寄出地址：">
              <el-select
                v-model="form.province"
                size="mini"
                placeholder="省"
                style="width: 100px"
                @change="getCity"
              >
                <el-option label="全部" :value="0"></el-option>
                <el-option
                  v-for="item in resData.province"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="form.city"
                size="mini"
                placeholder="市"
                style="width: 100px"
                @change="getDistrict"
              >
                <el-option label="全部" :value="0"></el-option>
                <el-option
                  v-for="item in city"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="form.district"
                size="mini"
                placeholder="区/县"
                style="width: 100px"
              >
                <el-option label="全部" :value="0"></el-option>
                <el-option
                  v-for="item in district"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-input
                v-model="form.address"
                placeholder="地址1"
                size="mini"
                style="width: 300px"
              ></el-input>
            </el-form-item>
            <el-form-item label="收件人姓名：">
              <el-input
                v-model="form.consignee"
                placeholder="收件人姓名"
                size="mini"
                style="width: 300px"
              ></el-input>
            </el-form-item>
            <el-form-item label="收件人电话：">
              <el-input
                v-model="form.mobile"
                placeholder="收件人电话"
                size="mini"
                style="width: 300px"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>

        <span v-if="resData" slot="footer" class="dialog-footer">
          <el-button @click="onCloseDialog">取 消</el-button>
          <span v-if="handle_type_index == 1">
            <el-button
              v-if="hanle_status != 7 && hanle_status != 8"
              type="primary"
              @click="submitData"
              >确 定</el-button
            >
          </span>
        </span>
      </el-dialog>
    </div>
    <preview-image
      v-if="showImg"
      :imgs="imgs"
      :show="showImg"
      @closeBox="closeImg"
    ></preview-image>
  </div>
</template>

<script>
import PreviewImage from "../../../components/PreviewImage.vue";

export default {
  components: { PreviewImage },
  props: {
    work_id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showImg: false,
      imgs: [],
      model: {
        id: 0,
        sub_id: 0,
      },
      parent_porblem_id: "0",
      porblem_id: "0",
      subPorblem: [],
      resData: {},
      show: true,
      loading: false,
      fullscreenLoading: false,
      form: {
        district: 0,
        city: 0,
        province: 0,
        mobile: "",
        address: "",
        consignee: "",
      },
      hanle_status: "",
      work: [],
      blp_type: [],
      province: [],
      city: [],
      district: [],
      handle_type_index: "",
      order_address: {},
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    imgClick(imgs) {
      this.showImg = true;
      this.imgs = imgs;
    },
    closeImg() {
      this.showImg = false;
    },
    fetchData() {
      this.fullscreenLoading = true;
      this.$http
        .post("/erp/Work/getCbInfo", {
          work_id: this.work_id,
        })
        .then((result) => {
          this.fullscreenLoading = false;
          if (result.data.code != 200) {
            return this.$message.error(result.data.msg);
          }
          const workData = result.data.data.work;
          this.subPorblem = [];
          this.problem = result.data.data.problem;
          this.problem.forEach((item) => {
            if (item.problem_id == workData.parent_id) {
              this.subPorblem = item.children;
            }
          });
          this.model.sub_id = Number(workData.problem_id);
          this.model.id = Number(workData.parent_id);
          this.order_address = result.data.data.order_address;
          if (this.order_address) {
            this.form.mobile = this.order_address.mobile;
            this.form.address = this.order_address.address;
            this.form.consignee = this.order_address.consignee;
            const re = new Promise((resolve, rejected) => {
              this.city = [];
              this.district = [];
              this.form.city = 0;
              this.form.district = 0;
              this.fullscreenLoading = true;
              this.$http
                .post("/erp/Common/getCity", {
                  province: this.order_address.province,
                })
                .then((res) => {
                  this.fullscreenLoading = false;
                  if (res.data.code == 200) {
                    this.city = res.data.data.list;
                    this.form.province = this.order_address.province;
                    resolve(1);
                  }
                });
            });

            re.then((r) => {
              this.form.district = 0;
              this.district = [];
              this.fullscreenLoading = true;
              this.$http
                .post("/erp/Common/getDistrict", {
                  city: this.order_address.city,
                })
                .then((res) => {
                  this.fullscreenLoading = false;
                  if (res.data.code == 200) {
                    this.district = res.data.data.list;
                    this.form.city = this.order_address.city;
                    this.form.district = this.order_address.district;
                  }
                });
            });
          }
          this.blp_type = result.data.data.blp_type;
          this.resData = result.data.data;
          this.hanle_status = this.resData.work.handle_status_index;
          this.handle_type_index = this.resData.work.handle_type_index;
        })
        .catch((err) => {});
    },
    submitData() {
      const data = this.form;
      this.fullscreenLoading = true;
      this.$http
        .post("/erp/Work/editAddressByWork", {
          work_id: this.work_id,
          form: this.form,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code != 200) {
            return this.$message.error(res.data.msg);
          }
          this.onCloseDialog();
          return this.$message.success(res.data.msg);
        });
    },
    getBlpText(e) {
      let text = "";
      if (e == 0 || e == "") {
        return "正常";
      }
      this.blp_type.forEach((v) => {
        if (e == v.key) {
          text = v.label;
        }
      });
      return text;
    },
    getCity(id) {
      this.city = [];
      this.district = [];
      this.form.city = 0;
      this.form.district = 0;
      if (!id) {
        return;
      }
      this.fullscreenLoading = true;
      this.$http
        .post("/erp/Common/getCity", {
          province: id,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 200) {
            this.city = res.data.data.list;
          }
        });
    },
    getDistrict(id) {
      this.form.district = 0;
      this.district = [];
      if (!id) {
        return;
      }
      this.fullscreenLoading = true;
      this.$http
        .post("/erp/Common/getDistrict", {
          city: id,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 200) {
            this.district = res.data.data.list;
          }
        });
    },
    onCloseDialog() {
      this.$emit("onCloseDialog", false);
    },
  },
};
</script>

<style scoped>
.el-form-item label {
  width: 150px !important;
}

.el-form-item__content {
  margin-left: 150px !important;
}

.blp-box {
  display: flex;
  flex-direction: row;
}

.blp-text {
  width: 50px;
}

.blp-input {
  width: 130px;
  margin-right: 10px;
}

.blp-note {
  width: 120px;
}

.blp-op {
  margin-left: 10px;
}

.blp-img-up {
  margin-left: 10px;
  width: 40px;
}

.el-icon-picture {
  font-size: 20px;
}
.header-box {
  width: 100%;
  height: 30px;
  padding: 5px;
  font-size: 18px;
  line-height: 30px;
  background-color: rgb(243, 243, 243);
}
.el-table__row td {
  padding: 5px 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/work/components/CbAddressInfo.vue